import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    mapToolsControl: {
      position: 'fixed',
      left: '48%',
      bottom: '25px',
      transform: 'translateX(100%)',
      margin: '0',
      padding: '0',
      border: 'none',
      borderRadius: '4px',
      pointerEvents: 'auto',
      zIndex: 1000,
    },
    toolsTitle: {
      fontSize: '11px',
      fontWeight: 600,
      color: '#FFFFFF',
      backgroundColor: '#FFFFFF40',
      padding: '2px 8px',
      borderRadius: '5px',
    },
    tooltip: {
      backgroundColor: '#1A1C19',
      color: '#FFFFFF',
      fontSize: '12px',
      padding: '2px 8px',
      borderRadius: '5px',
      border: 'none',
      margin: '8px',
    },
    toolsContainer: {
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '4px',
      overflow: 'hidden',
    },
    iconButton: {
      backgroundColor: '#FFFFFF',
      border: '1px solid rgba(0,0,0,0.2)',
      borderRadius: 0,
      width: 32,
      height: 32,
      color: '#001D29',
      padding: 0,
      margin: 0,
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
      '&[aria-label="Navegar pelo mapa"]': {
        borderTopLeftRadius: 4,
        borderBottomLeftRadius: 4,
      },
      '&[aria-label="Centralizar região"]': {
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
      },
    },
    activeButton: {
      backgroundColor: '#001D29',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#001D29',
        color: '#FFFFFF',
      },
    },
  }),
)
